module.exports = __webpack_public_path__ + "img/3.6889b95b.jpg";